import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Button, Input } from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import classnames from 'classnames/bind';
import { UI_DATE_FORMAT } from '../../../constants/statics';
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper';
import styles from '../styles.scss';
import YearMonthForm from './yearMonthForm';
import getWrappedMaskedInput from './getWrappedMaskedInput';
const cx = classnames.bind(styles);
class InputWrapper extends Component {
    static propTypes = {
        ...commonPropTypes,
        showError: PropTypes.bool.isRequired,
        compact: PropTypes.bool,
        modifiable: PropTypes.bool,
        orientation: PropTypes.oneOf(['top', 'bottom']),
        disabledDays: PropTypes.object,
        onBlur: PropTypes.func,
    };
    static defaultProps = {
        compact: false,
        modifiable: false,
        orientation: 'bottom',
    };
    constructor(props) {
        super(props);
        this.dayPickerInput = undefined;
        this.unparsedDate = '';
        this.state = {
            month: new Date(),
        };
    }
    get innerInput() {
        return _.get(this.dayPickerInput, 'input.input.inputElement', {});
    }
    get dayPickerProps() {
        const { modifiable, disabledDays } = this.props;
        const modifiableProps = {
            month: this.state.month,
            captionElement: this.renderCaptionElement,
        };
        const dayPickerProps = {};
        if (modifiable) {
            _.merge(dayPickerProps, modifiableProps);
        }
        if (disabledDays) {
            _.merge(dayPickerProps, { disabledDays });
        }
        return dayPickerProps;
    }
    formatDate = (date, format) => moment(date).format(format);
    isValidDate = (s, format) => moment(s, format, true).isValid();
    parseDate = (s, format) => {
        this.unparsedDate = s;
        const dateMoment = moment(s, format, true);
        return dateMoment.isValid() ? dateMoment.toDate() : undefined;
    };
    focusInput = (pos = 0) => {
        const input = this.innerInput;
        if (input && input.focus) {
            input.focus();
            input.selectionStart = pos;
            input.selectionEnd = pos;
        }
    };
    onDayChange = val => {
        const { format, onChange } = this.props;
        if (typeof onChange !== 'function') {
            return;
        }
        if (this.isValidDate(val, format)) {
            onChange(this.formatDate(val, format));
        }
        const pos = this.innerInput.selectionStart;
        _.defer(() => {
            if (!this.innerInput.value) {
                onChange('');
            }
            this.focusInput(pos);
        });
    };
    handleYearMonthChange = month => {
        this.setState({ month });
    };
    renderCaptionElement = ({ date, localeUtils }) => {
        const { elmId } = this.props;
        return (_jsx(YearMonthForm, { elmId: elmId, date: date, localeUtils: localeUtils, onChange: this.handleYearMonthChange }));
    };
    render() {
        const { disabled, elmId, value, label, placeholder, showError, format, className, compact, modifiable, orientation, onBlur, ...rest } = this.props;
        const newClassName = classnames({
            compact,
            [className]: true,
        });
        return (_jsxs(Input, { error: showError, actionPosition: 'left', className: `${cx('datepicker')} ${newClassName}`, "data-elm-id": `${elmId}_datepicker`, disabled: !!disabled, ...rest, children: [_jsx(Button, { icon: 'calendar alternate', onClick: this.focusInput, disabled: !!disabled, as: 'a' }), _jsx(DayPickerInput, { ref: el => (this.dayPickerInput = el), value: value, onDayChange: this.onDayChange, format: format, formatDate: this.formatDate, parseDate: this.parseDate, placeholder: format, keepFocus: true, dayPickerProps: this.dayPickerProps, classNames: {
                        overlay: '',
                        overlayWrapper: cx('datepicker-overlay-wrapper', orientation),
                        container: cx('datepicker-container', 'datepicker-input'),
                    }, component: getWrappedMaskedInput(placeholder, !!disabled), inputProps: { name: rest.name, onBlur } })] }));
    }
}
const DatePickerField = formFieldWrapper((fieldProps, showError) => (_jsx(InputWrapper, { ...fieldProps, showError: showError, format: fieldProps.placeholder || UI_DATE_FORMAT })));
DatePickerField.propTypes = commonPropTypes;
export default DatePickerField;
//# sourceMappingURL=index.js.map